context = null
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

export default (component) ->
	if !context?
		context = DragDropContext(HTML5Backend)
	context component

